import http from '@/utils/http'
import { networkData } from "@/v3/modules/exam/views/recordQuestion/utils/data";

export const updateStandAnswer = (params) => http.put(`/marking-exam-manager/stand/${params.examId}/crop`, params.examStandVos)
//标记已经处理
export const disposePaper = (params) => http.post('/marking-main/exam/exam/dispose_paper', params)
export const clearPaper = (params) => http.post('/marking-main/exam/exam/clear_paper', params)
export const clearCrop = (examId) => http.delete(`/marking-exam-manager/stand/${examId}/crop`)

export const cleanQuest = id => http.put(`/marking-question-center/question/paper/quests/clean/V2/old?examId=${id}`).then(resp => {
  return {
    success: resp.code === 200,
    message: resp.message
  }
})

// 切题
export const getStandAnswer = (params) => http.get(`/marking-exam-manager/stand/${params.examId}/crop`).then(resp => {
  if (resp.success && resp.body) {
    resp.body.examStandVos = networkData.setQuestionTypeCode(resp.body.examStandVos)
  }
  return resp
})


export const getStandAnswerUrl = (params) => http.post('/marking-main/stand/url', params)
export const officeToImage = (params) => http.post('/marking-question-center/image/question/officeToImage', params, 'form')

// pdf录题
export const listByOfficeUrl = (params) => http.post('/marking-question-center/image/question/listByOfficeUrl', params, 'form') // 根据officeUrl查询图片
//录题
export const insertQuestion = (params) => http.post('/marking-question-center/question/paper/quests/old', params) // 暂时不处理，等后期重构后再处理
export const queryExamQuestion = (params) => http.get('/marking-question-center/question/paper/quests', params)

// 试卷上传错误
export const setPaperUploadError = params => http.put(`/marking-exam-manager/exam-list/${params.examId}/wrong-paper`) //试卷上传错误

// 标准答案
export const setStandAnswerConfirm = (params) => http.put(`/marking-exam-manager/stand/region/${params.examId}`, params) 	// 确认标准答案

export const queryPaperList = (params) => http.post('/marking-main/exam/exam/list_paper', params)

export const queryPaperSchool = (params) => http.post('/marking-main/exam/exam/list_paper_school', params, 'form')